import { useIntl } from 'react-intl';
import Image from '@alltrails/core/components/Image';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';

type AppleLaurelProps = { height: number };

const AppleLaurel = ({ height }: AppleLaurelProps) => {
  const intl = useIntl();
  const languageRegionCode = useLanguageRegionCode();

  const src = require(`./laurels/apple-laurel-${languageRegionCode}.svg`);

  return <Image alt={intl.formatMessage({ defaultMessage: 'Apple App Store App of the Year' })} src={src} height={height} />;
};

export default AppleLaurel;
